import { createSelector } from 'reselect'
import {
  getList,
  getFilter,
  getSort,
  getPagination,
  getQuery,
  getBulkSync
} from 'react-redux/selectors/media-player'
import {
  getFilter as getGlobalFilter
} from 'react-redux/selectors/app'

export default createSelector(
  [ getList, getFilter, getSort, getPagination, getGlobalFilter, getQuery, getBulkSync],
  (list, filter, sort, pagination, globalFilter, query, bulkSync) => {
    return Object.assign(
      {},
      list,
      sort,
      pagination,
      filter,
      query,
      bulkSync,
      {
        globalFilter: globalFilter.filter
      }
    )
  }
)



// WEBPACK FOOTER //
// ./src/app/component/media-player/selector.js